<template>
  <div>
    <form class="form-horizontal mt-3">
      <div class="row">
        <div class="col-md-4">
          <div class="row form-group">
            <label class="col-md-3 col-form-label">
              {{
                $t(
                  'school.academic.operation.profile_mgt.parentProfile.province'
                )
              }}
              <i class="fa fa-spinner spin" v-if="fetch_province"></i>
            </label>
            <div class="col-md-8">
              <select
                v-model.number="model.province_code"
                @change="getDistrict(model.province_code)"
                class="form-control"
                :class="{ 'is-invalid': errors.has('province_code') }"
              >
                <option value>{{ $t('select') }}</option>
                <option
                  v-for="(province, index) in provinces"
                  :key="index"
                  :value="province.province_code"
                  >{{ province.province_name }}</option
                >
              </select>
              <div class="invalid-feedback" v-if="errors.has('province_code')">
                {{ errors.first('province_code') }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row form-group">
            <label class="col-md-3 col-form-label">
              {{
                $t(
                  'school.academic.operation.profile_mgt.parentProfile.district'
                )
              }}
              <i class="fa fa-spinner spin" v-if="fetch_district"></i>
            </label>
            <div class="col-md-8">
              <select
                v-model.number="model.district_code"
                @change="getcommune(model.district_code)"
                class="form-control"
                :class="{ 'is-invalid': errors.has('district_code') }"
              >
                <option value>{{ $t('select') }}</option>
                <option
                  v-for="(dis, index) in districts"
                  :key="index"
                  :value="dis.district_code"
                  >{{ dis.district_name }}</option
                >
              </select>
              <div class="invalid-feedback" v-if="errors.has('district_code')">
                {{ errors.first('district_code') }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row form-group">
            <label class="col-md-3 col-form-label">
              {{
                $t(
                  'school.academic.operation.profile_mgt.parentProfile.commune'
                )
              }}
              <i class="fa fa-spinner spin" v-if="fetch_commune"></i>
            </label>
            <div class="col-md-8">
              <select
                v-model.number="model.commune_code"
                class="form-control"
                :class="{ 'is-invalid': errors.has('commune_code') }"
                @change="getVillage(model.commune_code)"
              >
                <option value>{{ $t('select') }}</option>
                <option
                  v-for="(com, index) in communes"
                  :key="index"
                  :value="com.commune_code"
                  >{{ com.commune_name }}</option
                >
              </select>
              <div class="invalid-feedback" v-if="errors.has('commune_code')">
                {{ errors.first('commune_code') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="row form-group">
            <label class="col-md-3 col-form-label">
              {{
                $t(
                  'school.academic.operation.profile_mgt.parentProfile.village'
                )
              }}
              <i class="fa fa-spinner spin" v-if="fetch_village"></i>
            </label>
            <div class="col-md-8">
              <select
                v-model.number="model.village_code"
                class="form-control"
                :class="{ 'is-invalid': errors.has('village_code') }"
              >
                <option value>{{ $t('select') }}</option>
                <option
                  v-for="(v, index) in villages"
                  :key="index"
                  :value="v.village_code"
                  >{{ v.village_name }}</option
                >
              </select>
              <div class="invalid-feedback" v-if="errors.has('village_code')">
                {{ errors.first('village_code') }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row form-group">
            <label class="col-md-3 col-form-label">{{
              $t('school.academic.operation.profile_mgt.parentProfile.house')
            }}</label>
            <div class="col-md-8">
              <input
                v-model="model.house_no"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('house_no') }"
              />
              <div class="invalid-feedback" v-if="errors.has('house_no')">
                {{ errors.first('house_no') }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row form-group">
            <label class="col-md-3 col-form-label">{{
              $t('school.academic.operation.profile_mgt.parentProfile.street')
            }}</label>
            <div class="col-md-8">
              <input
                v-model="model.street"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('street') }"
              />
              <div class="invalid-feedback" v-if="errors.has('street')">
                {{ errors.first('street') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <h1 class="ts-border-b-2 ts-py-3">
            {{
              $t(
                'school.academic.operation.profile_mgt.parentProfile.monthlyIncome'
              )
            }}
          </h1>
          <br />
        </div>
        <div class="col-md-4">
          <div class="row form-group">
            <label class="col-md-3"></label>
            <div class="col-md-8">
              <div class="radio radio-css">
                <input
                  v-model="model.mi_range_spare1"
                  type="radio"
                  id="mi_range_spare1"
                  :value="true"
                  name="radio"
                  @change="check('mi_range_spare1')"
                />
                <label for="mi_range_spare1"
                  >{{
                    $t(
                      'school.academic.operation.profile_mgt.parentProfile.lessThan'
                    )
                  }}
                  1000 USD</label
                >
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-3"></label>
            <div class="col-md-8">
              <div class="radio radio-css">
                <input
                  v-model="model.mi_range_spare2"
                  type="radio"
                  id="mi_range_spare2"
                  :value="true"
                  name="radio"
                  @change="check('mi_range_spare2')"
                />
                <label for="mi_range_spare2">1000USD - 3000USD</label>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-3"></label>
            <div class="col-md-8">
              <div class="radio radio-css">
                <input
                  v-model="model.mi_range_spare3"
                  type="radio"
                  id="mi_range_spare3"
                  :value="true"
                  name="radio"
                  @change="check('mi_range_spare3')"
                />
                <label for="mi_range_spare3">3000USD - 5000USD</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row form-group">
            <label class="col-md-3"></label>
            <div class="col-md-8">
              <div class="radio radio-css">
                <input
                  v-model="model.mi_range_spare4"
                  type="radio"
                  id="mi_range_spare4"
                  :value="true"
                  name="radio"
                  @change="check('mi_range_spare4')"
                />
                <label for="mi_range_spare4">5000USD - 8000USD</label>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-3"></label>
            <div class="col-md-8">
              <div class="radio radio-css">
                <input
                  v-model="model.mi_range_spare5"
                  type="radio"
                  id="mi_range_spare5"
                  :value="true"
                  name="radio"
                  @change="check('mi_range_spare5')"
                />
                <label for="mi_range_spare5">8000USD - 10000USD</label>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-3"></label>
            <div class="col-md-8">
              <div class="radio radio-css">
                <input
                  v-model="model.mi_range_spare6"
                  type="radio"
                  id="mi_range_spare6"
                  :value="true"
                  name="radio"
                  @change="check('mi_range_spare6')"
                />
                <label for="mi_range_spare6"
                  >{{
                    $t(
                      'school.academic.operation.profile_mgt.parentProfile.moreThan'
                    )
                  }}
                  10000USD</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'parentProfileAddress',
  props: ['value', 'validate', 'clear'],
  data() {
    return {
      model: {},
      fetch_province: true,
      fetch_district: false,
      fetch_commune: false,
      fetch_village: false,
      districts: [],
      communes: [],
      villages: [],
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
    this.setEditData()
  },
  computed: {
    ...mapState('parentProfile', ['provinces', 'edit_data'])
  },
  methods: {
    ...mapActions('parentProfile', ['getProvince']),
    getDistrict(code) {
      this.districts = this.communes = this.villages = []
      this.model.district_code = this.model.commune_code = this.model.village_code =
        ''
      if (code) {
        this.fetch_district = true
        this.$store
          .dispatch('parentProfile/getDistrict', code)
          .then(response => {
            this.districts = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetch_district = false
          })
      }
    },
    getcommune(code) {
      this.communes = this.villages = []
      this.model.commune_code = this.model.village_code = ''
      if (code) {
        this.fetch_commune = true
        this.$store
          .dispatch('parentProfile/getCommune', code)
          .then(response => {
            this.communes = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetch_commune = false
          })
      }
    },
    getVillage(code) {
      this.villages = []
      this.model.village_code = ''
      if (code) {
        this.fetch_village = true
        this.$store
          .dispatch('parentProfile/getVillage', code)
          .then(response => {
            this.villages = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetch_village = false
          })
      }
    },
    check(name) {
      this.setMIRangeToFalse()
      switch (name) {
        case 'mi_range_spare1':
          this.model.mi_range_spare1 = true
          break
        case 'mi_range_spare2':
          this.model.mi_range_spare2 = true
          break
        case 'mi_range_spare3':
          this.model.mi_range_spare3 = true
          break
        case 'mi_range_spare4':
          this.model.mi_range_spare4 = true
          break
        case 'mi_range_spare5':
          this.model.mi_range_spare5 = true
          break
        case 'mi_range_spare6':
          this.model.mi_range_spare6 = true
          break
      }
    },
    setMIRangeToFalse() {
      this.model.mi_range_spare1 = false
      this.model.mi_range_spare2 = false
      this.model.mi_range_spare3 = false
      this.model.mi_range_spare4 = false
      this.model.mi_range_spare5 = false
      this.model.mi_range_spare6 = false
    },
    async setEditData() {
      await this.getProvince().finally(() => {
        this.fetch_province = false
      })
      if (!_.isEmpty(this.edit_data)) {
        await this.getDistrict(this.edit_data.province_code)
        await this.getcommune(this.edit_data.district_code)
        await this.getVillage(this.edit_data.commune_code)
        ;(this.model.province_code = this.edit_data.province_code),
          (this.model.district_code = this.edit_data.district_code),
          (this.model.commune_code = this.edit_data.commune_code),
          (this.model.village_code = this.edit_data.village_code),
          (this.model.street = this.edit_data.street),
          (this.model.house_no = this.edit_data.house_no),
          (this.model.mi_range_spare1 = this.edit_data.mi_range_spare1),
          (this.model.mi_range_spare2 = this.edit_data.mi_range_spare2),
          (this.model.mi_range_spare3 = this.edit_data.mi_range_spare3),
          (this.model.mi_range_spare4 = this.edit_data.mi_range_spare4),
          (this.model.mi_range_spare5 = this.edit_data.mi_range_spare5),
          (this.model.mi_range_spare6 = this.edit_data.mi_range_spare6)
      }
    }
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    },
    clear: function(value) {
      if (value) {
        this.model = this.value
      }
    }
  }
}
</script>
